// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import UkeUI from 'uke-ui'
// import './styles/theme-var.scss'
import './styles/index.scss'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import i18n from './lang' // Internationalization
import gRac from './plugins/rac'
import VueDND from 'awe-dnd' // 拖拽指令
import GlobalConfig from './utils/global-config'
import CookieHelper from './utils/cookieHelper'
import Session from './logic/session'
import VueCodeMirror from 'vue-codemirror'
import componentRegister from './components/componentRegister'

// import './mock' // simulation data
Vue.use(VueCodeMirror)
Vue.use(VueDND)

Vue.config.productionTip = false

Vue.use(UkeUI, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// 路由同步到store
sync(store, router)

// 权限控制插件
Vue.use(gRac, {
  store
})

componentRegister(Vue)

// 获取配置
GlobalConfig.getConfig().then((data) => {
  CookieHelper.getInstance(`.${window.location.hostname}`)
  GlobalConfig.getInstance(data)

  const session = new Session()

  let checkPageAuth = function (list, code) {
    return !!list.find(item => item.code === code)
  }

  // 路由卫士
  let loadingInstance = null
  router.beforeEach((to, from, next) => {
    // 判断如果是从项目中返回登录页强制刷新页面以达到清空路由的效果
    if (to.name === 'Login' && from.name) {
      Vue.nextTick(() => {
        window.location.reload()
      })
    }
    if (to.name !== 'Login') {
      // 获取用户权限
      store.dispatch('setMenuList').then(() => {
        const ALL_MENU = store.state.menuModule.menuList
        const FILTER_MENU = store.state.menuModule.filterMenuList
        if (to.path === '/') return
        if (to.meta.auth) {
          // 静态JS加载时loading
          let inTab = !!store.state.tabModule.tabList.find(item => item.code === to.name)
          if (!inTab && !loadingInstance) {
            loadingInstance = UkeUI.Loading.service({ fullscreen: true })
          }
          if (session.checkSession()) {
            let toObj = { ...to }
            if (toObj.path.split('/').length > 3) toObj.name = toObj.path.split('/')[2]
            if (checkPageAuth(ALL_MENU, toObj.name)) {
              next()
            } else {
              next(FILTER_MENU[0].childMenu[0].url)
            }
          } else {
            next('/login')
          }
        } else {
          next()
        }
      })
    } else {
      next()
    }
  })
  router.afterEach((to, from) => {
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
  })
  new Vue({ // eslint-disable-line no-new
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    render: h => h(App)
  })
}).catch((err) => {
  console.warn('getConfig err', err)
})
